module.exports = __webpack_public_path__ + "static/media/9193471a.jpg";